import { useRef } from 'react'

export const useLazyRef = <T>(fn: () => NonNullable<T>) => {
	const ref = useRef<T | null>(null)

	if (!ref.current) {
		ref.current = fn()
	}

	return ref
}
